import React from "react";
import StationPopover from "../../FloorPlanModal/components/StationPopover";
import SignalPulse from "../../FloorPlanModal/components/SignalPulse";
import { getStationColor } from "../../FloorPlanModal/utils/stationUtils";
import { STATION_SIZE } from "../../FloorPlanModal/utils/constants";

const StaticStation = ({
  station,
  layoutType,
  position,
  selectedStationId,
  setSelectedStationId,
}) => {
  const stationColor = getStationColor(station.category);
  const isSelected = selectedStationId === station.id;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          cursor: "default",
          userSelect: "none",
          pointerEvents: "auto",
          display: "block",
          width: STATION_SIZE,
          height: STATION_SIZE,
          padding: 0,
          margin: 0,
          border: "none",
          boxSizing: "border-box",
          lineHeight: 0,
          transform: `translate(${position?.x || 0}px, ${position?.y || 0}px)`,
        }}
      >
        {station.category === "定位基站" && (
          <SignalPulse color={stationColor.primary} />
        )}
        <StationPopover
          station={station}
          stationColor={stationColor}
          isOpen={isSelected}
          layoutType={layoutType}
          activeLayoutType={layoutType}
          trigger="click"
          onOpenChange={(open) => {
            setSelectedStationId(open ? station.id : null);
          }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
              setSelectedStationId(isSelected ? null : station.id);
            }}
            style={{
              width: STATION_SIZE,
              height: STATION_SIZE,
              borderRadius: "50%",
              backgroundColor: stationColor.primary,
              border: `2px solid ${isSelected ? "#fff" : stationColor.primary}`,
              boxSizing: "border-box",
              boxShadow: isSelected
                ? `0 0 0 2px ${stationColor.primary}, 0 2px 8px ${stationColor.primary}88`
                : `0 2px 6px ${stationColor.primary}66`,
              transition: "all 0.2s ease",
              transform: isSelected ? "scale(1.2)" : "scale(1)",
              cursor: "pointer",
            }}
          />
        </StationPopover>
      </div>
    </div>
  );
};

export default StaticStation;
